// extracted by mini-css-extract-plugin
export var addViewLink = "_14-1";
export var availabilityIcon = "_14-16";
export var availabilitySelectionIcon = "_14-15";
export var backButton = "_14-2";
export var backIcon = "_14-z";
export var conversationCount = "_14-3";
export var dragHandle = "_14-5";
export var dropdown = "_14-e";
export var dropdownIcon = "_14-7";
export var dropdownOption = "_14-6";
export var dropdownTriangle = "_14-d";
export var expand = "_14-f";
export var folder = "_14-i";
export var folderItem = "_14-c";
export var icon = "_14-8";
export var iconRow = "_14-9";
export var image = "_14-a";
export var logo = "_14-b";
export var navContainer = "_14-h";
export var navigationFooter = "_14-g";
export var pageShell = "_14-0";
export var placeholderAvailable = "_14-11";
export var placeholderBox = "_14-14";
export var placeholderBusy = "_14-13";
export var placeholderUnavailable = "_14-12";
export var profile = "_14-k";
export var profileContainer = "_14-m";
export var profileDropdown = "_14-n";
export var profileImage = "_14-l";
export var profileMain = "_14-o";
export var profileSubtitle = "_14-q";
export var profileTitle = "_14-p";
export var reorderIcon = "_14-r";
export var sentLine = "_14-u";
export var settingsHeader = "_14-s";
export var sidenavTextColor = "_14-y";
export var spamLine = "_14-t";
export var subitemWithTag = "_14-4";
export var supportItems = "_14-j";
export var teamText = "_14-10";
export var viewLine = "_14-x";
export var viewLineButton = "_14-w";
export var viewLineButtons = "_14-v";